
export class DatatableComponent {
    originalData: any[] = [];
    currentData: any[] = [];
    currentPage: number = 1;
    rowsPerPage: number = 10;
    maxPageNumbersToShow: number = 3;
    filterTerm: string = '';
    visibleSearch = 1;
    selectorIDTable = "#data-table-component";
    sortBy: string = 'id';
    sortDirection: 'asc' | 'desc' = 'asc';
    controlCloseAllMenus = false;

    get paginatedData() {
        const startIndex = (this.currentPage - 1) * this.rowsPerPage;
        const endIndex = startIndex + this.rowsPerPage;
        return this.currentData.slice(startIndex, endIndex);
    }

    get totalPages(): number {
        return Math.ceil(this.currentData.length / this.rowsPerPage);
    }

    get pageNumbers(): (number | string)[] {
        const pages: (number | string)[] = [];

        if (this.totalPages <= this.maxPageNumbersToShow) {
            for (let i = 1; i <= this.totalPages; i++) {
                pages.push(i);
            }
        }
        else {
            let startPage: number, endPage: number;
            if (this.currentPage <= Math.ceil(this.maxPageNumbersToShow / 2)) {
                startPage = 1;
                endPage = this.maxPageNumbersToShow - 1;
            } else if (this.currentPage + Math.floor(this.maxPageNumbersToShow / 2) >= this.totalPages) {
                startPage = this.totalPages - this.maxPageNumbersToShow + 2;
                endPage = this.totalPages;
            } else {
                startPage = this.currentPage - Math.floor(this.maxPageNumbersToShow / 2) + 1;
                endPage = this.currentPage + Math.floor(this.maxPageNumbersToShow / 2) - 1;
            }
            if (startPage < 1) {
                startPage = 1
            }
            if (endPage > this.totalPages) {
                endPage = this.totalPages
            }
            if (startPage > 1) {
                pages.push(1);
                if (startPage > 2) {
                    pages.push('...');
                }
            }
            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
            if (endPage < this.totalPages) {
                if (endPage < this.totalPages - 1) {
                    pages.push('...');
                }
                pages.push(this.totalPages);
            }
        }
        return pages;
    }

    applyFilter(): void {
        //const searchTerm = this.filterTerm.toLowerCase();
        this.currentData = this.originalData;
        //this.currentData = this.originalData.filter(item => String(item.example).toLowerCase().includes(searchTerm));
        /* El filtro se hace al criterio de cada caso de uso, haga un override para implementar la busqueda de acuerdo a los campos que tiene*/
        this.currentPage = 1;
    }

    goToPage(page: any): void {
        if (page >= 1 && page <= this.totalPages) {
            this.currentPage = page;
        }
        this.goToStartView();
    }

    nextPage(): void {
        if (this.currentPage === this.totalPages || this.totalPages === 0) {
            return;
        }
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
        }
        this.goToStartView();
    }

    prevPage() {
        if (this.currentPage === 1) {
            return;
        }
        if (this.currentPage > 1) {
            this.currentPage--;
        }
        this.goToStartView();
    }

    goToStartView() {
        if (this.currentPage == this.totalPages) {
            try {
                if (this.pageNumbers.length < this.rowsPerPage) {
                    document.querySelector(this.selectorIDTable)?.scrollIntoView({ block: "start" })
                    window.scrollBy({
                        top: -135,
                    });
                }
            } catch (e) {
            }
        }
    }

    // Lógica de ordenamiento
    sortTable(column: string): void {
        if (this.sortBy === column) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortBy = column;
            this.sortDirection = 'asc';
        }
        this.sortData();
    }

    sortData(): void {
        this.originalData = [...this.originalData].sort((a, b) => {
            const valueA = a[this.sortBy];
            const valueB = b[this.sortBy];
            //Manejar null, undefined y valores no numéricos
            const isValueANum = !isNaN(parseFloat(valueA));
            const isValueBNum = !isNaN(parseFloat(valueB));
            let comparison = 0;
            if (isValueANum && isValueBNum) {
                // Si ambos son números (incluso si vienen como string), ordénalos numéricamente
                comparison = parseFloat(valueA) - parseFloat(valueB);
            } else if (!isValueANum && !isValueBNum) {
                // Si ambos son texto o no son números, ordénalos alfabéticamente
                const strA = String(valueA).toLowerCase();
                const strB = String(valueB).toLowerCase();
                if (strA < strB) {
                    comparison = -1;
                } else if (strA > strB) {
                    comparison = 1;
                }
            } else if (!isValueANum && isValueBNum) {
                // Si el valor A no es numérico y el valor B sí, pon B primero
                comparison = 1;
            } else {
                // Si el valor A es numérico y el valor B no, pon A primero
                comparison = -1;
            }
            // Ajustar por la dirección de ordenamiento
            return this.sortDirection === 'asc' ? comparison : -comparison;
        });
        this.applyFilter();
    }

    toggleMenu(item: any): void {
        
        let temp = [...this.currentData].map((item_local) => {
            
            if (item_local.$$key_data_id !== item.$$key_data_id) {
                return {
                    ...item_local,
                    $$isMenuOpen: false
                };
            }
            return { ...item_local, $$isMenuOpen: !item.$$isMenuOpen };
        });
        this.currentData = temp;
        this.controlCloseAllMenus = true;
    }


    toggleMenuAll() {
        let temp = [...this.currentData].map((item_local) => {
            return {
                ...item_local,
                $$isMenuOpen: false
            };
        });
        this.currentData = temp;
    }

    verificaArray(data: any) {
        return Array.isArray(data) ? data : [data]
    }
}